import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { RouterModule } from '@angular/router';
import { RelatoriosContent } from '@/shared/components/relatorios/relatorios-content';

@Component({
    selector: 'app-medico-relatorios-content',
    standalone: true,
    imports: [RouterModule, RelatoriosContent],
    template: `<app-relatorios-content [itens]="itens"></app-relatorios-content>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
/**
 * Shell dos relatórios do médico (menu de relatórios). Cada relatório resolve e exibe o médico
 * selecionado no próprio card ("médico selecionado + Alterar", ver `RelatorioMedicoBase`) — o
 * shell não mantém mais um card de pessoa fixo/somente-leitura.
 */
export class MedicoRelatoriosContent implements OnInit {
    itens: MenuItem[] = [];

    ngOnInit(): void {
        this.itens = [
            { label: 'Certificado de Regularidade', routerLink: 'certificado-regularidade' },
            { label: 'Controle Administrativo', routerLink: 'controle-administrativo' },
            { label: 'Ofício de Confirmação', routerLink: 'oficio-confirmacao' },
            { label: 'Ofício de Repúdio', routerLink: 'oficio-repudio' },
            { label: 'Certidão de Cancelamento', routerLink: 'certidao-cancelamento-medico' },
            { label: 'Certidão de Jubilamento', routerLink: 'certidao-jubilamento-medico' },
            { label: 'Certidão para Fins Internacionais', routerLink: 'certidao-fins-internacionais-medico' },
            { label: 'Certidão EME', routerLink: 'certidao-eme-medico' },
            { label: 'Certidão Cadastral', routerLink: 'certidao-cadastral-medico' },
            { label: 'Declaração de Inscrição', routerLink: 'certidao-inscricao-medico' },
            { label: 'Certidão de Quitação de Débito', routerLink: 'certidao-quitacao-debito-medico' },
            { label: 'Ficha Cadastral', routerLink: 'ficha-cadastral-medico' },
            { label: 'Ficha Cadastral Resumida', routerLink: 'ficha-cadastral-resumida-medico' },
            { label: 'Ficha Cadastral LGPD', routerLink: 'ficha-cadastral-lgpd-medico' },
            { label: 'Emissão de Etiquetas', routerLink: 'etiqueta-endereco-medico' },
            {
                label: 'Requerimento Único',
                icon: 'pi pi-angle-right',
                items: [{ label: 'Médico', routerLink: 'requerimento-unico-medico' }, { label: 'Pré-médico' }]
            },
            { label: 'Termo de Ciência e Compromisso', routerLink: 'termo-ciencia-compromisso-medico' },
            { label: 'Declaração de Responsabilidade de Pagamento', routerLink: 'declaracao-resp-pagamento-medico' },
            { label: 'Declaração de Médico Convocado', routerLink: 'declaracao-medico-convocado-medico' },
            { label: 'Ofício para Médico', routerLink: 'oficio-medico' },
            { label: 'Ofício de Cancelamento de Inscrição Secundária', routerLink: 'oficio-confirmacao-cancelamento-inc-secundaria-medico' },
            { label: 'Requerimentos Diversos', routerLink: 'requerimentos-diversos-medico' },
            { label: 'Declaração para Apresentação no Exterior', routerLink: 'declaracao-exterior-medico' },
            { label: 'Relatório por seleção', routerLink: 'relatorio-selecao' },
            { label: 'Etiqueta Profissional', routerLink: 'etiqueta-profissional' }
        ];

    }
}
